export enum ivaCondition {
  'Responsable Inscripto' = 1,
  'Responsable Monotributo' = 2,
  'Consumidor Final' = 3, 
  'Excento' = 4
}
